import { TechnicalSkillWithCompanyFragment } from 'generated/graphql';
import { TSelectOption } from '@spotted-zebra-uk/ui-components';

export type EditTechnicalSkillFormValues = {
  _id: number;
  subId: string;
  ownership: TSelectOption;
  name: string;
  description: string | null;
};

export function getInitialFormValues(
  technicalSkill: TechnicalSkillWithCompanyFragment
): EditTechnicalSkillFormValues {
  return {
    _id: technicalSkill.id,
    subId: technicalSkill.subId,
    ownership: {
      label: technicalSkill.company?.name ?? 'Global',
      value: technicalSkill.company?.id.toString() ?? '-1',
    },
    name: technicalSkill.name,
    description: technicalSkill.description || null,
  };
}

export const dataTestIds = {
  form: 'edit-technical-skill-drawer__form',
  editButton: 'edit-technical-skill-drawer__edit-button',
  archiveButton: 'edit-technical-skill-drawer__archive-button',
  saveButton: 'edit-technical-skill-drawer__save-button',
  cancelButton: 'edit-technical-skill-drawer__cancel-button',
  idInput: 'edit-technical-skill-drawer__id-input',
  subIdInput: 'edit-technical-skill-drawer__sub-id-input',
  ownerSelect: 'edit-technical-skill-drawer__owner-select',
  nameInput: 'edit-technical-skill-drawer__name-input',
  descriptionInput: 'edit-technical-skill-drawer__description-input',
};
